import { useState } from 'react';
import { IconButton } from '@mui/material';
import { Icon } from 'components/Icon';
import Modal from 'components/common/Modal';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

export const DeleteModalButton = ({
  itemSubject,
  itemName,
  onDelete,
  disabled = false,
}) => {
  const [modalStatus, setModalStatus] = useState({
    open: false,
    visible: false,
  });

  const toggleModal = () => {
    setModalStatus(v => ({ ...v, open: !v.open }));
    setTimeout(() => setModalStatus(v => ({ ...v, visible: !v.visible })), 200);
  };

  return (
    <>
      <IconButton
        data-no-dnd="true"
        size="small"
        disabled={disabled}
        sx={{
          width: '40px',
          height: '40px',
        }}
        onClick={toggleModal}>
        <Icon name="delete" />
      </IconButton>

      {(modalStatus.visible || modalStatus.open) && (
        <Modal
          data-no-dnd="true"
          setConfirmDialogAction={toggleModal}
          confirmDialogAction={{
            isOpen: true,
            title: `Remover item da ${itemSubject}?`,
            subTitle: itemName,
            confirmTextButton: 'Remover',
            color: 'error',
            children: (
              <div className="modalRemoveItem">
                <DeleteOutlineOutlinedIcon color="error" fontSize="8px" />
              </div>
            ),
            onConfirm: () => {
              onDelete();
              toggleModal();
            },
            showConfirmationButton: true,
            closeTextButton: 'Cancelar',
          }}
        />
      )}
    </>
  );
};
